import React from "react";
import {
    CloseApplicationType,
    applicationTypeLabels,
} from "@common/types/closeApplicationType";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./ApplicationTypeFilter.module.scss";

const applicationTypes = Object.values(CloseApplicationType);

const applicationTypesSet: ReadonlySet<string> = new Set(applicationTypes);

const options: FilterMultiselectOption[] = applicationTypes.map((type) => ({
    value: type,
    label: applicationTypeLabels[type],
    searchableLabel: applicationTypeLabels[type],
}));

export const ApplicationTypeFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.applicationTypes ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val
                        .map(String)
                        .filter((v): v is CloseApplicationType =>
                            applicationTypesSet.has(v),
                        );
                    onChange({
                        applicationTypes:
                            selected.length > 0 ? selected : undefined,
                    });
                }}
                name="applicationTypes"
                onBlur={noop}
            />
        </div>
    );
};
